import { AuthListPermissionTemplatesResponse } from 'api/actions/auth-list-permission-templates/auth-list-permission-templates-response';
import { AuthListPermissionsResponse } from 'api/actions/auth-list-permissions/auth-list-permissions-response';
import { createContext, useContext } from 'react';

export type Permission = AuthListPermissionsResponse[number];

export type PermissionTemplate = AuthListPermissionTemplatesResponse[number];

export interface PermissionDataContextValue {
  permissions: Permission[];
  permissionTemplates: PermissionTemplate[];
  globalPermissions: Permission[];
  organizationPermissions: Permission[];
  departmentPermissions: Permission[];
  organizationPermissionTemplates: PermissionTemplate[];
  departmentPermissionTemplates: PermissionTemplate[];
  getPermission: (idOrSlug: number | string) => Permission | undefined;
  getPermissionTemplate: (idOrSlug: number | string) => PermissionTemplate | undefined;
  getDefaultPermissionTemplate: () => PermissionTemplate;
}

/**
 * Permission Data context.
 */
export const PermissionDataContext = createContext<PermissionDataContextValue>(undefined!);

/**
 * Uses the Permission Data context.
 */
export function usePermissionDataProvider() {
  return useContext(PermissionDataContext);
}
